import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import AgendaPage from './AgendaPage';
import * as S from './styles';
import Text from 'components/Text';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';

const Agenda: React.FC = () => {
  const theme = useThemeContext();
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <S.AgendaContainer>
      <Accordion
        expanded={isOpen}
        onChange={handleToggle}
        disableGutters
        sx={{
          backgroundColor: theme.background.secondary,
        }}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              style={{
                color: theme.primary,
                fontSize: 36,
              }}
            />
          }
        >
          <Text size="large" color="white" bold>
            Agenda
          </Text>
        </AccordionSummary>
        <AccordionDetails>
          <AgendaPage />
        </AccordionDetails>
      </Accordion>
    </S.AgendaContainer>
  );
};

export default Agenda;
